import React from "react";
import one from './pics/one.jpeg';
import two from './pics/two.jpeg';
import three from './pics/three.jpeg';
import './Arbeitsvisum.css';

class Arbeitsvisum extends React.Component {
    render() {
        return (
            <article className="article br3 ba b--black-10 w-100 w-50-m w-50-l mw7 shadow-5 center">
                <main className="pa4 black-80">
                    <div className="measure">
                        <fieldset id="sign_up" className="ba b--transparent ph0 mh0">
                            <div className='legend center'>
                                <legend className="f1 fw6 ph0 mh0">فيزا بحث عن عمل لكل المجالات والأوراق المطلوبة للعمل و المعادلة</legend>
                            </div>
                            <hr/>

                            <div className="ui form ma0">
                                <div className="fields">
                                    <div class="row">
                                        <div class="column">
                                            <img alt='' width='250px' height='300px' src={one} />
                                        </div>
                                        <div class="column">
                                            <img alt='' width='250px' height='300px' src={two} />
                                        </div>
                                        <div class="column">
                                            <img alt='' width='500px' height='500px' src={three} />
                                        </div>
                                    </div>
                                    <hr/>
                                    <h3>
                                        فيزا البحث عن عمل فى ألمانيا هى أحد أنواع الفيزا فى ألمانيا ، وبالطبع الغرض منها مفهوم من اسمها وهو البحث عن عمل فى المانيا ، وتمنح هذه الفيزا لمدة 6 أشهر وإذا حصل الشخص على العمل فى المانيا من خلال فيزا العمل فإنه يمكنه البقاء على أرض ألمانيا دون العودة إلى بلده وتقديم طلب تحويل الفيزا من فيزا البحث عن عمل إلى إقامة عمل فى ألمانيا بشكل رسمى
                                        <br/>
                                        البحث عن العمل في الوقت الحالي مش متاحة للمجال الطبى
                                        <br/>
                                        والمتاح للأطباء هي فيزا
                                        <br/>
                                        a17 = بغرض معادلة الشهادة الطبية
                                        <br/>
                                        b16 = بغرض اتمام اللغة لمعادلة الشهادة الطبية
                                        <br/>
                                        <br/>
                                        و تعرف بالمعادلة و دى بوست مجمع عنها
                                        <br/>
                                        (الطب البشرى و الاسنان و الصيدلة و البيطرى) <a target='_blank' rel='noreferrer' href='https://www.facebook.com/groups/311111149267612/permalink/467381180307274/'>من هنا</a>
                                        <br/>
                                        ______________________________________
                                        <br/>
                                        <br/>
                                        مرفق بالبوست .. الاوراق المطلوبة لفيزا البحث عن العمل و فيزا العمل و فيزا المعادلة للاطباء و فيزا استكمال اللغة للأطباء
                                        <br/>
                                        ______________________________________
                                        <br/>
                                        لازم عشان تعرف مهنتك او وظيفتك متاحة هناك في المانيا فلازم تبدأ تبحث عنها في مواقع الشغل في المانيا
                                        <br/>
                                        بعض مواقع للبحث عن عمل في المانيا
                                        <br/>
                                        <div className='lft'>
                                            <a target='_blank' rel='noreferrer' href='http://www.make-it-in-germany.com'>make-it-in-germany.com</a>
                                            <br/>
                                            <a target='_blank' rel='noreferrer' href='https://www.jobbörse.de'>jobbörse.de</a>
                                            <br/>
                                            <a target='_blank' rel='noreferrer' href='https://www.linkedin.com'>linkedin.com</a>
                                            <br/>
                                            <a target='_blank' rel='noreferrer' href='https://www.absolventa.de'>absolventa.de</a>
                                            <br/>
                                            <a target='_blank' rel='noreferrer' href='https://www.monster.de'>monster.de</a>
                                            <br/>
                                            <a target='_blank' rel='noreferrer' href='https://www.stepstone.de'>stepstone.de</a>
                                            <br/>
                                            <a target='_blank' rel='noreferrer' href='https://www.xing.com'>xing.com</a>
                                            <br/>
                                            <a target='_blank' rel='noreferrer' href='https://de.indeed.com'>de.indeed.com</a>
                                            <br/>
                                            <a target='_blank' rel='noreferrer' href='http://de.dice.com'>de.dice.com</a>
                                            <br/>
                                            <a target='_blank' rel='noreferrer' href='https://www.kimeta.de'>kimeta.de</a>
                                            <br/>
                                            <a target='_blank' rel='noreferrer' href='https://www.stepstone.de/en'>stepstone.de</a>
                                            <br/>
                                            <a target='_blank' rel='noreferrer' href='https://www.jobmensa.de'>jobmensa.de</a>
                                            <br/>
                                            <a target='_blank' rel='noreferrer' href='https://www.jobkralle.de/jobs'>jobkralle.de/jobs</a>
                                            <br/>
                                            <a target='_blank' rel='noreferrer' href='https://www.jobworld.de'>jobworld.de</a>
                                            <br/>
                                            <a target='_blank' rel='noreferrer' href='https://www.gulp.de'>gulp.de</a>
                                            <br/>
                                            <a target='_blank' rel='noreferrer' href='https://www.yourfirm.de'>yourfirm.de</a>
                                            <br/>
                                            <a target='_blank' rel='noreferrer' href='http://www.praktikum.de'>praktikum.de</a>
                                            <br/>
                                            <a target='_blank' rel='noreferrer' href='http://berlinstartupjobs.com/'>berlinstartupjobs.com</a>
                                            <br/>
                                            <a target='_blank' rel='noreferrer' href='https://www.pst.ag/'>pst.ag</a>
                                            <br/>
                                            <a target='_blank' rel='noreferrer' href='https://stackoverflow.com/'>stackoverflow.com</a>
                                            <br/>
                                            <a target='_blank' rel='noreferrer' href='https://www.jobboerse.arbeitsagentur.de'>jobboerse.arbeitsagentur.de</a>
                                            <br/>
                                            <a target='_blank' rel='noreferrer' href='https://www.glassdoor.com/index.html'>glassdoor.com/index.html</a>
                                            <br/>
                                            <a target='_blank' rel='noreferrer' href='https://www.anerkennung-in-deutschland.de/html/en/index.php'>anerkennung-in-deutschland.de/html/en/index.php</a>
                                            <br/>
                                            <a target='_blank' rel='noreferrer' href='http://www.arbeiten.de/jobs/arbeit-in-deutschland.html'>arbeiten.de/jobs/arbeit-in-deutschland.html</a>
                                            <br/>
                                            <a target='_blank' rel='noreferrer' href='http://de.jobrapido.com/'>de.jobrapido.com</a>
                                            <br/>
                                            <a target='_blank' rel='noreferrer' href='http://www.bewerbungsdschungel.com'>bewerbungsdschungel.com</a>
                                            <br/>
                                            <a target='_blank' rel='noreferrer' href='http://www.planet-beruf.de/schuelerinnen/'>planet-beruf.de/schuelerinnen</a>
                                            <br/>
                                            <a target='_blank' rel='noreferrer' href='https://www.arbeitsagentur.de/'>arbeitsagentur.de</a>
                                            <br/>
                                            الموقع دة للمهندسين المدنى
                                            <br/>
                                            <a target='_blank' rel='noreferrer' href='http://www.bauingenieur24.de/stellenmarkt'>bauingenieur24.de/stellenmarkt</a>
                                            <br/>
                                            <a target='_blank' rel='noreferrer' href='https://www.google.de'>google.de</a> و أخيرا موقع جوجل ألمانيا
                                        </div>
                                        ___________________________________
                                        <br/>
                                        بعض الملاحظات
                                        <br/>
                                        فيه بعض المواقع بتطلب منك انك تسجل فيها و تعمل أكونت و تعمل سى فى
                                        <br/>
                                        فيه أشخاص فى بعض المواقع بيبقوا زى السماسرة و بيبقا وسيط ما بينك و بين الشركة
                                        <br/>
                                        متدفعش لحد فلوس لو قالك لازم رقم حساب و تدفع عشان يجيلك عقد " نصباية"
                                        <br/>
                                        بعض الوظائف ممكن مبتطلبش ألمانى و بتطلب إنجليزى فالبحث مهم
                                        <br/>
                                        الخبرة مهمة و فى الغالب بتلاقيها من الشروط
                                        <br/>
                                        متتعبش و متملش و ابحث كتير
                                        <br/>
                                        أي حاجه فيها فلوس طبعا فاكس و نصباية
                                        <br/>
                                        ______________________________________
                                        <br/>
                                        الاوراق المطلوبة
                                        <br/>
                                        <a target='_blank' rel='noreferrer' href='https://kairo.diplo.de/contentblob/4391688/Daten/4776946/downloaddatei_visaantrag_langzeitvisum_eng_arab.pdf'>
                                            1- ابلكيشن السفارة
                                        </a>
                                        <br/>
                                        <a target='_blank' rel='noreferrer' href='https://kairo.diplo.de/contentblob/866046/Daten/24366/download_biopaesse_fotomustertafel.pdf'>
                                            ومتنسوش ال 3 صور الشخصية
                                        </a>
                                        <br/>
                                        <a target='_blank' rel='noreferrer' href='https://kairo.diplo.de/contentblob/4002944/Daten/6869211/rk_visa_belehrungsblatt_fuer_schengenvisum_eng.pdf'>
                                            2- الاقرار القانوني وقع عليه وامضي فقط
                                        </a>
                                        <br/>
                                        3- معظم اللى دخل السفارة مكنش معاه حساب مغلق بس كان فاتح حساب في مصر بمبلغ 4500 يورو و ممكن ما يوازيهم بالجنية المصرى
                                        <br/>
                                        تحديث " 10-2019"
                                        <br/>
                                        المبلغ المطلوب حوالى 5200 يورو
                                        <br/>
                                        - فيزا المعادلة للاطباء a17 اكتر من 6 شهور فحاولوا تشوفوا اللينك اللى فى اول البوست و تفهموا هى كام شهر
                                        <br/>
                                        5- لو رايح تشتغل بالألمانى فيفضل يكون معاك ع الاقل
                                        <br/>
                                        B2 / B1
                                        <br/>
                                        و لو رايح شغل بالانجليزى فيكون معاك ايلتس و ميقلش عن 6 مثلا
                                        <br/>
                                        و يبقا معاك مثلا المانى A1 or A2
                                        <br/>
                                        10 – لازم تثبت ان شهادتك الجامعية معتمدة في المانيا و هتعرف من <a target='_blank' rel='noreferrer' href='https://www.facebook.com/groups/311111149267612/permalink/444540182591374/'>البوست</a> دة
                                        <br/>
                                        13- الايميلات اللى بينك و بين الشركات ع الأقل تبين انك بحثت
                                        <br/>
                                        14- يعنى شهادة خبرة / كورسات / اتش ار / اى حاجة زيادة مش مكتوبة في الورقة دى ولازم طبعا تكون بالانجليزى او ألمانى
                                        <br/>
                                        ______________________________________
                                        <br/>
                                        و دول بعض التجارب للحصول على الفيزا من السفارة الألمانية فى مصر
                                        <br/>
                                        July 5, 2016
                                        <br/>
                                        بسم الله الرحمن الرحيم .. كل عام وانتم بخير وعيد سعيد عليكم
                                        <br/>
                                        ناس كتير طلبت منى اقولهم عن نوع الفيزا دى لالمانيا .. ف ان شاء الله هشرح الفيزا وطريقتها هنا عسى ان تنفع حد ولو فى اى استفسار ربنا يقدرنى واجاوب
                                        <br/>
                                        اولا الفيزا دى مش زى ماهو شائع للاطباء فقط .. الفيزا دى لاى مهنة ليها مجال وسوق عمل فى المانيا .. ومدتها 6 اشهر فقط تدور فيهم على شغل هناك ..
                                        <br/>
                                        الفيزا مش طالبة ليفل معين من الللغة الالمانية .. الا انهم ممكن يرخموا على بعض الناس ويطلبوا ليفل معين (غالبال الرخامة دى بتبقى على الاطباء او اى مهنة بتتعامل بصفة مباشرة مع مواطنين المان )
                                        <br/>
                                        طبعا كاى فيزا بتحجز معاد وتروح تقدم ورقك وبتتسال سؤالين عاديين خالص رايح فين هتدور على شغل ازاى ( ودة بتبتقى محضرة فى search plan بتدقمها مع الورق ) هتعد فين ( ودى بتجيبلهم حجز هوستل او اى مكان هتعد فية ومش لازم عقد شقة 6 شهور يعنى ) وبتسال الكام سؤال دول بس غالبا بيبقى حد رخم اللى بيسال عشان يجيب اخرك وبتمشى والرد فى خلال شهر تقريبا ولو فى اى حاجة هما عاوزينها منك بيتصلوا بيك يقوللولك عاوزين كذا
                                        <br/>
                                        لازم تبقى عامل تأمين طبى لمدة 6 شهور ومعاك حساب بنكى فية حوالى اكتر من 45 الف جنية ( مش حساب مغلق فى المانيا ولا حاجة .. حساب هنا عادى خالص ) وللضمان فى ناس ساعات بيترخم عليها ويقولوهم هاتوا حساب بنكى ( غالبا دى فى حالة انهم مش مقتنعين ان مجالك لية شغل هناك فدة نوع من انواع الرخامة بس ) وللضمان زى ماقولت هات ضامن معاك .. والدك او والدتك بكشف حساب محترم ليهم وتعمل ورقة انهم ضامنين ليك وبيمضوا فى السفارة وببتوثق الورقة هناك وبتقدمها
                                        <br/>
                                        بس كدة
                                        <br/>
                                        ............................................
                                        <br/>
                                        November 20, 2016
                                        <br/>
                                        الحمد لله والفضل لله تعالي ..
                                        <br/>
                                        كنت مقدم على فيزا بحث عن عمل والحمد لله لسه واصلانى .. حكتب التجربه لعلها تكون مفيده ..
                                        <br/>
                                        الفيزا اخدت بالظبط 10 ايام من ساعة ما قدمت ورقى لحد ما استلمتها .. الورق اللى قدمته يالظبط :
                                        <br/>
                                        ابلكيشن الفيزا
                                        الاقرار القانونى الجديد
                                        <br/>
                                        شهادة البكالوريوس وبيان مواد ودرجات مترجم وموثق ف السفاره (ااسفاره خدت الصور وسابتلى الاصل )
                                        <br/>
                                        كشف حساب من بنك ف مصر .. بس كان فيه مبلغ كبير . محدش سألني على حساب البنك ف المانيا
                                        <br/>
                                        CV & Motivation letter ( all in English)
                                        <br/>
                                        حجز اوتيل .. وهى دى كانت اكتر حاجه اهتموا ف السؤال عنها ف انترفيو السفاره . انت حتقعد فين هناك ومدن ايه اللى ناوى تدور فيها على شغل واشمعنى الدن دى .. وانا كتبت اسماء شركات انا كنت عملت معاها انترفيوز قبل كده وطبعت الرسايل اللى بعتوهالى عشان الانترفيوز
                                        <br/>
                                        شهادة A2 من ADK
                                        <br/>
                                        شهادة IELTS
                                        <br/>
                                        HR letter من الشغل عندى فىه مرتبي الحالى
                                        <br/>
                                        انا مجالى IT
                                        <br/>
                                        وكان بقالى حوالى 6 شهور بدور على شغل وجالى كذا انترفيو من اكتر من شركه كل ده ضروري تقوله وتقدم كل ال ميلات دى . اهم حاجه اهتموا بيها هو انت حتدور على شغل فين وايه نوعية الشغل والمدن اللى حتدور فيها واشمعنى المدن دى
                                        <br/>
                                        انترفيو السفاره كان بالضبط ربع ساعه واتسألت كام سؤال المانى على انجلش كانت كلها حوالين خطتك ايه وشغلك ايه وكده
                                        <br/>
                                        ..............................................
                                        <br/>
                                        February 2. 2017
                                        السلام عليكم
                                        <br/>
                                        احب انقل لكم تجربتى يمكن تفيد حد
                                        <br/>
                                        أنا قدمت على فيزا بحث عن عمل في مجال هندسة البرمجيات
                                        <br/>
                                        جاتلي الفيزا بعد معاد الانترفيو بحوالي شهر و إسبوع
                                        <br/>
                                        الأوراق اللي قدمتها
                                        <br/>
                                        - حجز فندق مبدئي (حجزت في هوستل ١٠ أيام)
                                        <br/>
                                        - تأمين صحي من أليانز
                                        <br/>
                                        - bank statement كنت حاطط في حسابي الفلوس باليورو
                                        <br/>
                                        كان ساعتها الفورم الجديد بتاع الحساب المغلق و كنت باعت إيميلات ل deutsche bank عشان معرفتش أبعت ورق إيه بالزبط، مردوش عليا، حاولت مع بنوك تانية موافقوش، المهم قدمت من غير حساب مغلق
                                        <br/>
                                        - شهادة التخرج و بيان بالمواد والدرجات متوثقين من السفارة
                                        <br/>
                                        - لازم تثبت إن شهادة الجامعة معترف بها في ألمانيا هتدور على جامعتك و تخصصك من على موقع أنابين و تطبع الصفحة و تاخدها معاك
                                        <br/>
                                        - CV
                                        <br/>
                                        لازم يكون فورما معترف بيها في ألمانيا
                                        مثال من <a target='_blank' rel='noreferrer' href='https://www.uni-due.de/imperia/md/content/abz/muster_lebenslauf.pdf'>موقع جامعة دويسبورغ</a>
                                        <br/>
                                        - Motivation Letter
                                        <br/>
                                        لازم تكتب فيها ليه إخترت المدينة اللي هتقدم عليها و ناوي تدور على شغل إزاي search plan
                                        <br/>
                                        - شهادة لغة يفضل طبعا ألماني و إنجليزي أنا كنت مقدم بألماني A2 و ايلتس
                                        <br/>
                                        - شهادة خبرة من HR
                                        <br/>
                                        بقيت الأوراق
                                        <br/>
                                        - أهم حاجة الإيميلات اللي بينك وبين الشركات في ألمانية عشان تثبت إنك فعلا بتدور على شغل و فعلا ليك فرصة كويسة إنك تلاقي شغل لو كان معاك كمان معاد انترفيو في ألمانيا يبقى كويس جدا. لازم تطبع الإيميلات و تاخدها معاك حتى لو كانت إيميلات رفض (بس يستحسن يكون معاك كم إيميل يثبت إنك عملت انترفيوز)
                                        <br/>
                                        كام ملحوظة كدة
                                        <br/>
                                        - الموظفة سألتني ليه مافتحتش حساب مغلق و إقتنعت لما ورتلها الإيميلات بتاعت البنوك
                                        <br/>
                                        - ماتفكرش تقدم على الفيزا إلا لما تكون جربت تقدم على شغل الأول. لازم تكون متأكد إن ليك فرصة كويسة تلاقي شغل. نصيحتي إبدأ فكر بعد ما تعمل ١٠ انترفيوز أو أكتر. لازم يكون عندك إكسبرينس كويسة عشان الشغل في ألمانيا عايز ناس شاطرة
                                        <br/>
                                        - الورق اللي قدمته كان كله بالإنجليزي
                                        <br/>
                                        ___________________________________
                                        <br/>
                                        اخيرا بقا
                                        <br/>
                                        - متفكرش تقدم غير لما يكون معاك خبرة ع الاقل سنة
                                        <br/>
                                        - لو انت معاك دبلومة او اى شهادة غير الثانوية فتقدر تدخل ع موقع انبيان و تشوف شهادتك معتمدة والا لاء
                                        <br/>
                                        - لو انت هتقدم ع مجال غير مجالك فلازم يبقا معاك خبرة و خبرة كويسة و اتقال ليا ان فيه اتنين دخلوا ع مجال غير مجالهم واحد اترفض و واحد لاء فبلاش مجازفة
                                        <br/>
                                        - لو انت ملقتش شغل فى خلال ال ٦ شهور معرفش ممكن تكمل والا ترجع مصر
                                        <br/>
                                        - لو انت اشتغلت فتقدر تعمل لم شمل للزوجة والاطفال
                                        <br/>
                                        - ممكن وانت بتبحث من و انت هنا فى مصر فممكن تجيب عقد عمل ومتطلعش بحث عن عمل و تطلع ع عمل علطول و مش هتحتاج حساب بنكى.. فمتفقدش الامل يعنى و حاول
                                        <br/>
                                        - فيه اكتر من مهندس راسلوا الشركات و حصلوا على عقد عمل و هو مش معاه شهادات لغة المانى والا انجليزى بس كان بيتكلم انجليزى كويس و الشركة وافقت بيه و السفارة مطلبتش شهادة لغة
                                        <br/>
                                        ..............................................
                                        <br/>
                                        <a target='_blank' rel='noreferrer' href='https://www.facebook.com/groups/311111149267612/permalink/440709422974450/'>تجربة الحصول على البلو كارد</a>
                                    </h3>
                                </div>
                            </div>
                        </fieldset>
                    </div>
                </main>
            </article>
        );
    }
}

export default Arbeitsvisum;
